import { Box, Container, Typography } from "@material-ui/core";
import React from "react";

function NotFound() {
  return <>
  <Container maxWidth="md">
    <Box alignItems="center" justifyContent="center" display="flex" height="100vh">    
    <Typography variant="h2" align="center">
        404 | Not Found
      </Typography>
    </Box>
  </Container>
  </>;
}

export default NotFound;